
import React from 'react'
import { Helmet } from 'react-helmet';
import Auth from '../../Auth'

import FormPage from '../FormPage'
import InternationPhoneInput from "../../components/form/InternationPhoneInput";

class ClientConsultantProfile extends FormPage
{
    static path = '/client-success-rep';

    static ShowChatWidget = true;

    /**
     * The css class for the page container
     *
     * @var {String}
     */
    static BGClass = 'bordered-panel client-user-form';

    /**
     * The max width in pixels for the form container
     *
     * @var {Integer}
     */
    static MaxWidth = 800;

    /**
     * The title shown on the form
     */
	static FormTitle = "clients.consultant_profile.title";

	/**
     * The submit button title for the form
     */
	static FormSubmit = false;

	/**
     * The fields mapping for the form
     */
    formFields()
    {
        let fields = [

            {
                style: styles.fieldSection,
                fields: {
                    first_name: {
                        label: 'clients.consultant_profile.first_name_label',
                        required: true,
                        columns: 6,
                        style: styles.field,
                    },
                    last_name: {
                        label: 'clients.consultant_profile.last_name_label',
                        required: true,
                        columns: 6,
                        style: styles.field,
                    },
                },
            },
            {
                style: styles.fieldSection,
                fields: {
                    email: {
                        label: 'clients.consultant_profile.email_label',
                        type: 'email',
                        required: true,
                        columns: 6,
                        style: styles.field,
                    },
                    phone: {
                        label: 'clients.consultant_profile.phone_label',
                        required: false,
                        type: 'antd-input',
                        children: (
                            <InternationPhoneInput/>
                        ),
                        columns: 6,
                        style: styles.field,
                    },
                },
            },
            {
                style: styles.fieldSection,
                fields: {
                    job_title: {
                        label: 'clients.consultant_profile.job_label',
                        required: false,
                        columns: 6,
                        style: styles.field,
                    },
                },
            }
        ]
        if (this.state.model.image_path) {
            fields.unshift({
                fields: {
                    image_path: {
                        label: 'clients.consultant_profile.image_label',
                        type: 'pixie',
                        ratio: '1:1',
                        circular: true,
                        required: false,
                    },
                },
            })
        }
    	return this.transFormFields(fields);
	}

    /**
     * [Constructor]
     *
     * @param {Object} props
     * @returns {FormPage}
     */
    constructor(props)
    {
		super(props);

		this.state = {
			...this.state,
			model: {...Auth.user().clientOrg?.().consultant},
			isDisabled: true,
		};
	}

	/**
     * Handles successful responses returned by TB Request
     *
     * @param {Object} responseData
     * @returns void
     */
	onSuccess(responseData)
	{
		//
	}
}

export default () => {
    return (
         <>
              <Helmet>
                   <title>My Client Lead | Wripple</title>
              </Helmet>
              <ClientConsultantProfile />
         </>
    )
}


const styles = {
	fieldSection: {
		flexDirection: 'row'
	},
	field: {
		padding: '0 15px',
	},
};